export const FETCH_STATUS = 'terms.FETCH_STATUS';
export const FETCH_STATUS_SUCCESS = 'terms.FETCH_STATUS_SUCCESS';
export const FETCH_STATUS_FAILURE = 'terms.FETCH_STATUS_FAILURE';
export const FETCH_CURRENT = 'terms.FETCH_CURRENT';
export const FETCH_CURRENT_SUCCESS = 'terms.FETCH_CURRENT_SUCCESS';
export const FETCH_CURRENT_FAILURE = 'terms.FETCH_CURRENT_FAILURE';
export const ACCEPT_TERMS = 'terms.ACCEPT_TERMS';
export const ACCEPT_TERMS_SUCCESS = 'terms.ACCEPT_TERMS_SUCCESS';
export const ACCEPT_TERMS_FAILURE = 'terms.ACCEPT_TERMS_FAILURE';
